import { Factory } from 'miragejs';
import faker from 'faker';

export default Factory.extend({
  name() {
    return faker.company.catchPhrase();
  },
  code() {
    return faker.random.alpha({ count: 5, casing: 'upper' }).toUpperCase();
  },
  teacherCount() {
    return faker.datatype.number({ max: 5 });
  },
  studentCount() {
    return faker.datatype.number({ max: 35 });
  },
});
